import { DesktopChart } from "./desktop-chart"
import { withPropsValidation } from "../views"
import { withScreens } from "../screens"
import React from "react"
import ReactDOM from "react-dom"
import schema from "./schema"

function benchmarkPercentileChart(el, props) {
  ReactDOM.render(
    <Chart
      bottomQuartile={props.bottom_quartile}
      comparison={props.comparison}
      comparisonName={props.comparison_name}
      name={props.name}
      max={props.max}
      median={props.median}
      min={props.min}
      topQuartile={props.top_quartile}
      benchmarkType={props.benchmark_type}
      primaryFactorNarrative={props.primary_factor_narrative}
    />,
    el,
  )

  return {
    destroy: () => {
      ReactDOM.unmountComponentAtNode(el)
    },
  }
}

export default withPropsValidation(benchmarkPercentileChart, schema)

const Chart = withScreens(props => {
  return <DesktopChart {...props} />
})
